<template>
  <a-modal
          title="抽样项目详情"
          okText="确定"
          cancelText="取消"
          width="900px"
          :visible="visible"
          :confirm-loading="confirmLoading"
          @ok="handleOk"
          @cancel="handleCancel"
  >
    <a-form-model ref="ruleForm" :model="formState" :rules="rules" :label-col="{span:8}" :wrapper-col="{span:16}">
      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="受检单位名称" prop="name">
            <a-input v-model="param.name"></a-input>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="12">
          <a-form-model-item label="抽样品种" prop="pickType">
            <a-input v-model="param.pickType"></a-input>
          </a-form-model-item>
        </a-col>

        <a-col span="12">
          <a-form-model-item label="抽样数量" prop="pickCount">
            <a-input v-model="param.pickCount"></a-input>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="12">
          <a-form-model-item label="联系人" prop="connectName">
            <a-input v-model="param.connectName"></a-input>
          </a-form-model-item>
        </a-col>

        <a-col span="12">
          <a-form-model-item label="联系电话" prop="tel">
            <a-input v-model="param.tel"></a-input>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="详细地址" prop="address">
            <a-input v-model="param.address"></a-input>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:0}" :wrapperCol="{span:24}" prop="badThings">
            <a-ext-bad-things-select :project-id="param.projectId" v-model="formState.badThings"></a-ext-bad-things-select>
          </a-form-model-item>
        </a-col>
      </a-row>


      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:0}" :wrapperCol="{span:24}" prop="monitCheckList">
            <a-ext-choice-checker-and-count :needCheckCount="param.pickCount" v-model="formState.monitCheckList"></a-ext-choice-checker-and-count>
          </a-form-model-item>
        </a-col>
      </a-row>

    </a-form-model>

  </a-modal>
</template>

<script>


import AExtBadThingsSelect from '../../../components/AntDesignExt/All/AExtBadThingsSelect'
import AExtChoiceCheckerAndCount from '../../../components/AntDesignExt/All/AExtChoiceCheckerAndCount'


import {publishMonitPick as saveApi,getPublishMonitPick as initApi} from '../../../api/api'

export default {
    name: "FormModel",
    components:{
        AExtBadThingsSelect,AExtChoiceCheckerAndCount},
    props:{
        visible:{
            type:Boolean,
            default:false
        },
        param:{
            type:Object,
            default: ()=>{
                return {}
            }
        }
    },
    data() {
        return {
            confirmLoading: false,
            formState: {
                badThings:'',
                monitCheckList:[]
            },
            rules: {

            },

        };
    },
    created(){
        this.initForm();
    },
    methods: {
        initForm(){
            if(this.param.id) {
                this.confirmLoading = true;
                initApi(this.param.id).then((result => {
                    this.formState = result.data.data;
                    this.confirmLoading = false;
                })).catch(() => {
                    this.confirmLoading = false;
                });
            }
        },
        handleOk(e) {
            // alert(JSON.stringify({id:this.param.id,...this.formState}))
            let total=0;
            this.formState.monitCheckList.forEach(item=>{
                total=total+item.checkCount;
            });
            if(this.param.pickCount!==total)
            {
                alert('分配数量不一致')
                return;
            }
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    this.confirmLoading = true;
                    saveApi({id:this.param.id,...this.formState}).then((result=>{
                        this.confirmLoading = false;
                        this.$emit("publishCheckModalClose",true)
                        this.$emit("update:visible",false)
                    })).catch(()=>{
                        this.confirmLoading = false;
                    });
                } else {
                    return false;
                }
            });
        },
        handleCancel(e) {
            this.$emit("update:visible",false)
        },

    },
}
</script>

<style scoped lang="scss">

  /deep/ .ant-modal-body{
    /*height: 60vh;*/
    /*overflow-y: scroll;*/
  }

</style>